import { PhoneNumberDto, UserDto } from '@act/shared/data-transfer-objects';
import {
  CollapsibleCardContent,
  CollapsibleCardHeader,
  IconLibrary,
} from '@act/storybook';
import { Typography } from '@mui/material';
import { Fragment } from 'react';
import usePhoneNumberDialog from 'react-components/dialog-forms/hooks/use-phone-number-dialog';
import PhoneNumberEntry from '../PhoneNumberEntry';

export interface PhoneContactCardProps {
  member: UserDto;
  phoneNumbers: PhoneNumberDto[];
  defaultClosed?: boolean;
  onToggle?: () => void;
}

const PhoneContactContent = ({
  member,
  phoneNumbers,
}: PhoneContactCardProps) => {
  const openPhoneNumberDialog = usePhoneNumberDialog();

  return (
    <>
      <CollapsibleCardHeader
        title="Phone number"
        titleTypographyVariant="subheadMedium"
        avatar={<IconLibrary iconName="DeviceMobile" size={24} />}
        actions={[
          {
            display: 'Edit phone number',
            ddTrackingName: 'edit-phone-number-button',
            disabled: !phoneNumbers?.length,
            callback: () =>
              openPhoneNumberDialog({
                mode: 'Edit',
                memberId: member?.id,
                phoneNumbers,
              }),
          },
        ]}
        secondaryActions={[
          {
            display: 'Add phone number',
            ddTrackingName: 'add-phone-number-button',
            callback: () =>
              openPhoneNumberDialog({
                mode: 'Add',
                memberId: member.id,
                phoneNumbers,
              }),
          },
          {
            display: 'Set primary phone',
            ddTrackingName: 'set-primary-phone-number-button',
            disabled: !phoneNumbers.length,
            callback: () =>
              openPhoneNumberDialog({
                mode: 'SetPrimary',
                memberId: member.id,
                phoneNumbers,
              }),
          },
          {
            display: 'Delete phone number',
            ddTrackingName: 'delete-phone-number-button',
            disabled: !phoneNumbers.length,
            callback: () => {
              void openPhoneNumberDialog({
                mode: 'Delete',
                memberId: member.id,
                phoneNumbers,
              });
            },
          },
        ]}
      />
      <CollapsibleCardContent twoColumn>
        {!phoneNumbers?.length && <Typography>No record found</Typography>}
        {!!phoneNumbers?.length && (
          <Fragment>
            {phoneNumbers?.map(p => (
              <PhoneNumberEntry
                phoneNumber={p}
                key={`${p.id}-${p.interactableId}`}
              />
            ))}
          </Fragment>
        )}
      </CollapsibleCardContent>
    </>
  );
};

export default PhoneContactContent;
